import {BehaviorSubject, Subject} from "rxjs";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class Invite {
  resetForm = new Subject<void>();
  disableForm = new Subject<boolean>();
  resetExistingUserForm = new Subject<boolean>();
  markUsernameAsUnverified = new Subject<any>();
  markUsernameAsVerified = new Subject<any>();
  hasAssociatedLar = new BehaviorSubject<boolean>(false);
  isExpandAdultSection = new Subject<boolean>();
  isVerifyDisabled = new Subject<boolean>();
}
